import { render } from "./LangSelector.vue?vue&type=template&id=1d4b7515"
import script from "./LangSelector.vue?vue&type=script&lang=js"
export * from "./LangSelector.vue?vue&type=script&lang=js"

import "./LangSelector.vue?vue&type=style&index=0&id=1d4b7515&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__